import React, {
  useMemo,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import PropTypes from "prop-types";
import { FormikContext } from "formik";
import { Loading, SectionContent, SelectControl } from "../../../../components";
import { envs, links } from "../../../../config";
import { CondicoesGeraisForm } from "../../../../forms";
import { useStaticJsonRequest } from "../../../../hooks";
import { distinctArray, mapToOptions } from "../../../../utils";
import * as S from "./BaixarCondicoesGerais.Style";

const Formulario = ({ mapeamento }) => {
  const { values, submitForm, setFieldValue } = useContext(FormikContext);

  const productsOptions = useMemo(() => {
    const produtos = distinctArray(mapeamento.map((item) => item.produto));
    return mapToOptions(produtos);
  }, [mapeamento]);

  const planoOptions = useMemo(() => {
    const produtos = distinctArray(
      mapeamento
        .filter((item) => item.produto === values.produto)
        .map((item) => item.plano)
    );
    return mapToOptions(produtos);
  }, [mapeamento, values.produto]);

  const resetPlano = useCallback(() => {
    setFieldValue("plano", values.produto && "", false);
  }, [setFieldValue, values.produto]);

  useEffect(() => {
    resetPlano();
  }, [resetPlano]);

  useEffect(() => {
    const { produto, plano } = values;

    const { path } = {
      ...mapeamento?.find(
        ({ produto: p, plano: pl }) => p === produto && pl === plano
      ),
    };

    setFieldValue("condicaoGeralLink", path);

    if (path) {
      submitForm();
    }
  }, [mapeamento, setFieldValue, submitForm, values]);

  return (
    <>
      <SelectControl
        options={productsOptions}
        name="produto"
        label="Produto"
        placeholder="Selecione"
      />
      <SelectControl
        options={planoOptions}
        name="plano"
        label="Plano"
        placeholder="Selecione"
      />
    </>
  );
};

Formulario.propTypes = {
  mapeamento: PropTypes.arrayOf(
    PropTypes.shape({
      produto: PropTypes.string.isRequired,
      plano: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const BaixarCondicoesGerais = () => {
  const { data: mapeamento, loading } = useStaticJsonRequest(
    links.capitalizacao.mapaCondicoesGerais
  );

  const [{ condicaoGeralLink }, setCondicaoGeral] = useState({
    condicaoGeralLink: "",
    plano: "",
    produto: "",
  });

  return (
    <Loading loading={loading}>
      <SectionContent>
        <S.FormContent>
          <CondicoesGeraisForm
            form={Formulario}
            mapeamento={mapeamento || []}
            onSelectCondicaoGeral={setCondicaoGeral}
          />
        </S.FormContent>
        <S.ButtonCondicoesGerais
          href={`${envs.hostStaticCdn}${condicaoGeralLink}`}
          target="_blank"
          label="Baixar condições gerais"
          disabled={!condicaoGeralLink}
          bSize="sm"
        />
      </SectionContent>
    </Loading>
  );
};

BaixarCondicoesGerais.propTypes = {};

export default BaixarCondicoesGerais;
